import { admin, guest } from 'apprise-core/auth';
import { User } from 'apprise-core/user';
import { useLoginConfig } from 'apprise-frontend-iam/login/context';
import { useLogin } from 'apprise-frontend-iam/login/logged';
import { usePrecannedUser } from 'apprise-frontend-iam/login/precanned';
import { useUserCalls } from 'apprise-frontend-iam/user/client';
import { useCrud } from 'apprise-ui/utils/crudtask';
import { useLoggedUserCalls } from './client';



export const useLoggedStore = () => {

    const login = useLogin()
    const config = useLoginConfig()
    const calls = useLoggedUserCalls()
    const users = useUserCalls()
    const crud = useCrud({ singular: 'user.singular' })

    const precanned = usePrecannedUser()

    const updateTask = crud.saveOneWith(async (logged: User) =>

        login.login(await users.updateProfile(logged))

    )
    const self = {

        fetchLoggeduser: crud.fetchOneWith(async () => {

     
            const fetch = async () => {
 
                try {

                    return await calls.fetchLoggedUser()

                }
                catch (error: any) {


                    // legacy java services are not mode-aware and will return 401 if we introspect on in guest mode or open mode.
                    // here we simulate the behaviour of newer java services that return a user that matches the mode.
                    const loginRequired = error.response?.status === 401 || error.response?.status === 403

                    if (loginRequired) {
                        
                        if (config.mode === 'guest-allowed')
                            return guest

                        if (config.mode === 'open')
                            return admin

                    }
                    
                    throw error
                }


            }

            // we adapt precannaed users that we may get back in non-walled modes.
            const user = precanned.of(await fetch())

            login.login(user)


        })
            .with(config =>

                config.show('user.load_logged').error("user.load_logged_error")

            )
            .done()



        ,

        // optionally takes task configurer callback.
        update: updateTask.with(config => {

            config.show('user.updating_profile')

        })
            .done()

        ,

        updateTask




    }

    return self


}


